/**
 * hw-h5
 */

var supplier_kfc = {
  name: "肯德基",
  supplier: "kfc",
  img: `https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/goods-images-1259573531/20231225/4gei707ec02d4u8a73b6zp4r.png`
};

var supplier_mdl = {
  name: "麦当劳",
  supplier: "mcdonald",
  img: "https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/goods-images-1259573531/20231225/nhsicsb89gj3o2q95obsg3gz.png"
};

var supplier_array = [
  supplier_mdl,
  supplier_kfc,
  {
    name: "星巴克",
    supplier: "sbk",
    img: "https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/goods-images-1259573531/20231225/olwyxuizvpoggkvdsjb4iiqe.png"
  },
  {
    name: "瑞幸",
    supplier: "luckin",
    img: "https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/goods-images-1259573531/20231225/h6ibqddr5yk7g7tax9lljg2t.png"
  },
  {
    name: "奈雪",
    supplier: "nayuki",
    img: "https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/goods-images-1259573531/20231225/kfnm2cra01jf9zc293n616ln.png"
  },
  {
    name: "汉堡王",
    supplier: "burgerking",
    img: "https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/goods-images-1259573531/20231225/lqqjshqmq5f2sfzo49r9xfnx.png"
  }
];

var goods_mdl = [
  {
    title: "【特价】圆筒冰淇淋+麦辣鸡翅1对",
    img: ""
  },
  {
    title: "薯条（中）双份",
    img: ""
  },
  {
    title: "超值巨无霸汉堡套餐",
    img: ""
  }
];

var goods_kfc = [
  {
    title: "人气餐随心配",
    img: "https://dx-pub-test.oss-cn-beijing.aliyuncs.com//kentucky/product_image110741601912520094?Expires=1994378998&OSSAccessKeyId=LTAI5t97pVJgyx2w7UWxE5sg&Signature=qBjpPti6twMKpz8MyydN2tSpDI4%3D"
  },
  {
    title: "劲爆鸡米花大份",
    img: "https://kentucky.oss-cn-beijing.aliyuncs.com/kentucky/product_image7272151016794107?Expires=1890567434&OSSAccessKeyId=LTAI4FhynmbAyMW4S3ceLtvT&Signature=y%2Bs9rRf3YqRUls5SKFK%2BY21sVdw%3D"
  },
  {
    title: "【特价】老北京鸡肉卷",
    img: "https://kentucky.oss-cn-beijing.aliyuncs.com/kentucky/product_image7520116499560590?Expires=1901350066&OSSAccessKeyId=LTAI4FhynmbAyMW4S3ceLtvT&Signature=eteQmn%2B0ZE9xlCS81T68CiqvWkg%3D"
  }
];

export {
  supplier_array,
  supplier_mdl,
  supplier_kfc,
  goods_mdl,
  goods_kfc
}